export const inputDateRegex = /^\d{4}-\d{2}-\d{2}$/
export const inputTimeRegex = /^\d{2}:\d{2}$/
